/** Define all error code separated by feature */
export namespace ErrorCodeEnum {
  export const boUser = Object.freeze({
    invalidUsernameOrPassword: 'invalidUsernameOrPassword',
    inActiveUser: 'inActiveUser',
    userRoleNotFound: 'userRoleNotFound',
    userNoPermission: 'userNoPermission',
  });

  export const product = Object.freeze({
    productLinked: 'productLinked',
    rewardInsufficientCode: 'rewardInsufficientCode',
  });

  export const rewardCode = Object.freeze({
    fileCSVParseError: 'fileCSVParseError',
    fileUploadFail: 'fileUploadFail',
    fileCodeCountNotMatchQuantityLimit: 'fileCodeCountNotMatchQuantityLimit',
  });
}
